export default __webpack_public_path__ + "static/bcs_coding_kids-a80ae183dbf29e94f86f8a25b3fdf5f2.jpg";